import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';
import { Navigator } from 'src/app/components/menu/navigator';
import { WebservicesService } from '../webservices/webservices.service';
import { CustomerModel } from 'src/app/models/customer-model';
import { UserSessionService } from '../user-session/user-session.service';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class ContestService {

  public contest: any[] = [];
  public customer: CustomerModel;

  constructor(
    private readonly navigator: Navigator,
    private readonly userSession: UserSessionService,
    private readonly webservices: WebservicesService
  ) {

  }

  private getContest(): Observable<any> {
    return from(this.userSession.getCustomerPromise()).pipe(
      switchMap((customer: CustomerModel) => {
        this.customer = customer;
        const obj: any = {
          customer_id: customer.customerId,
          session_token: this.userSession.sessionToken,
        };
        return this.webservices.get('bonus/get-valid-contests', obj);
      })
    );
  }

  private createContestList(response: any): void {
    if (response?.result === 1 && response?.payload) {
      this.contest = response.payload;
    }
  }

  public postContest(data) {
    const obj: any = {
      contestId: data.contest_id,
      customer_id: this.customer.customerId,
      session_token: this.userSession.sessionToken,
      firstName: data.firstName,
      lastName: data.lastName,
      dob: data.birthDate,
      //allowPromoEmails: data.allowPromoEmails,
      email: data.email
    };
    return this.webservices.post("bonus/add-marketing-contest-player", obj);
  }

  public postAllowEmail(allowPromoEmails: boolean) {
    const obj: any = {
      customer_id: this.customer.customerId,
      session_token: this.userSession.sessionToken,
      allowPromoEmails: allowPromoEmails,
    };
    return this.webservices.post("authentication/update-account", obj);
  }

  async getValidContest(): Promise<any[]> {
    try {
      const response = await this.getContest().toPromise();
      this.createContestList(response);
      return this.contest;
      //return this.contest.filter((contest) => contest.enabled);
    } catch (error) {
      console.error('Get contest error', error);
      return [];
    }
  }

  public openContest(data: any): void {
    this.navigator.navigateTo('ContestComponent', {
      customModalClass: 'contest-screen',
      multipleModals: false
    },
      {
        contestData: data
      });
  }
}
